<template>
	<div class="view-list">
		<v v-if="isVerticalScreen()" />
		<h v-else />
	</div>
</template>
<script>
	import {
		mapGetters
	} from 'vuex'
	import H from './H.vue';
	import V from './V.vue';
	export default {
		name: 'List',
		components: {
			H,
			V
		},
		data() {
			return {
				
			}
		},
		methods: {
			...mapGetters(["isVerticalScreen"]),
		}
	}
</script>
<style scoped lang="less">
	.view-list {
		width: 100%;
	}
	::v-deep {
		.pop-list {
			width: calc(189px * var(--scale-rate)); 
			padding: calc(35px * var(--scale-rate)) calc(10px * var(--scale-rate)) calc(10px * var(--scale-rate));
			color: #000000;
			overflow: hidden;
			position: absolute;
			border-bottom-right-radius: calc(10px * var(--scale-rate));
			border-bottom-left-radius: calc(10px * var(--scale-rate));
			z-index: 9999;
			.bg {
				width: 100%;
				height: calc(275px * var(--scale-rate));
				object-fit: cover;
				position: absolute;
				top: 0;
				left: 0;
				z-index: 0;
			}
			.list-wrapper {
				z-index: 1;
				width: 100%;
				max-height: calc((275px - 35px - 10px) * var(--scale-rate));
				overflow-x: hidden;
				overflow-y: auto;
				.item-wrapper {
					width: 100%;
					height: 0;
					padding-top: 66.6666667%;
					position: relative;
					margin-bottom: calc(5px * var(--scale-rate));
					cursor: pointer;
					.project-img {
						position: absolute;
						top: 0;
						height: 0;
						width: 100%;
						height: 100%;
						object-fit: fill;
					}
					.inf-container {
						width: calc(100% / var(--scale-rate));
						height: 32px;
						background-color: rgba(58, 58, 61, 0.58);
						position: absolute;
						bottom: calc(4px * var(--scale-rate));
						color: #FFFFFF;
						transform: scale(var(--scale-rate));
						transform-origin: 0 100%;
						padding-left: 10px;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: flex-start;
						.name {
							font-size: 12px;
							width: 100%;
						}
						.location {
							font-size: 12px;
							width: 100%;
						}
					}
					&:last-child {
						margin-bottom: 0;
					}
				}
				
			}
		}
	}
</style>